import React, { useState } from 'react'
import { Button } from 'react-admin'
import CloseIcon from '@material-ui/icons/Close'
import DoneIcon from '@material-ui/icons/Done'
import { putRequestStatus } from '../../api/tournament'

const RequestActionField = ({ participantId }) => {
  const [loading, setLoading] = useState(false)
  const handleStatus = async (participantId, status) => {
    setLoading(true)
    try {
      await putRequestStatus(participantId, status)
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      <Button
        disabled={loading}
        onClick={() => handleStatus(participantId, 'accepted')}
      >
        <DoneIcon />
      </Button>
      <Button
        disabled={loading}
        onClick={() => handleStatus(participantId, 'declined')}
      >
        <CloseIcon />
      </Button>
    </>
  )
}

export default RequestActionField
